import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import item1 from "../images/item1.svg";
import item2 from "../images/item2.svg";
import item3 from "../images/item3.svg";
import item4 from "../images/item4.svg";
import item5 from "../images/item5.svg";

let thermo_objs = {};

function Panel(props) {
  const { t } = useTranslation();
  const [stateSpot, setStateSpot] = useState(1);
  const [stateSpotW, setStateSpotW] = useState(60);
  const [stateSpotH, setStateSpotH] = useState(60);

  const [currentPopupThermo, setCurrentPopupThermo] = useState(null);
  const [stateThermostats, setStateThermostats] = useState([]);
  const [thermoPopup, setThermoPopup] = useState(0);
  const [addedThermo, setAddedThermo] = useState([{ id: "none" }]);
  const [mobileToolsOpen, setMobileToolsOpen] = useState(false);

  // Dynamic links for the “room layout” steps (Room size, Cold spots, Thermostat)
  const [roomStepLink, setRoomStepLink] = useState("/standartmode");
  const [thermoStepLink, setThermoStepLink] = useState("/standartmode?thermo=1");

  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const pathname = url.pathname; // e.g. /standartmode, /imgmode, /floortype, /result
      const figType = url.searchParams.get("fig_type");
      const modeParam = url.searchParams.get("mode");
      const thermoParam = url.searchParams.get("thermo");

      let mode = null;
      if (modeParam) {
        mode = Number(modeParam);
      } else {
        if (pathname.includes("standartmode")) mode = 1;
        else if (pathname.includes("imgmode")) mode = 2;
      }

      // Work out base path for the layout steps
      let baseRoomPath = "/standartmode";
      if (pathname.includes("standartmode")) {
        baseRoomPath = "/standartmode";
      } else if (pathname.includes("imgmode")) {
        baseRoomPath = "/imgmode";
      } else {
        if (mode === 1) baseRoomPath = "/standartmode";
        else if (mode === 2) baseRoomPath = "/imgmode";
      }

      // Room size / Cold spots link – keep fig_type on standard mode if available
      let roomLink = baseRoomPath;
      if (baseRoomPath === "/standartmode" && figType) {
        roomLink += `?fig_type=${figType}`;
      }
      setRoomStepLink(roomLink);

      // Thermostat link – same base path but with thermo=1 (+ fig_type if we know it)
      let thermoLink = baseRoomPath;
      const params = [];

      if (baseRoomPath === "/standartmode" && figType) {
        params.push(`fig_type=${figType}`);
      }

      // If already on a thermo step keep thermo=1, otherwise enforce it
      if (thermoParam === "1" || thermoParam === 1) {
        params.push("thermo=1");
      } else {
        params.push("thermo=1");
      }

      if (params.length > 0) {
        thermoLink += `?${params.join("&")}`;
      }

      setThermoStepLink(thermoLink);
    } catch (e) {
      setRoomStepLink("/standartmode");
      setThermoStepLink("/standartmode?thermo=1");
    }
  }, []);

  useEffect(() => {
    if (stateThermostats.length < 1 && Number(props.page) === 5) {
      fetch(process.env.REACT_APP_BE_HOST + "/thermostats")
        .then((response) => response.json())
        .then((data) => {
          const availableThermostats = data.filter(
            (thermostat) =>
              thermostat.name?.trim().toUpperCase() !== "NGT-2.0-STND"
          );
          thermo_objs = {};
          availableThermostats.forEach((elm) => {
            thermo_objs[elm.id] = { ...elm };
          });
          setStateThermostats(availableThermostats);
        });
    }
  }, [props.page, stateThermostats.length]);

  return (
    <>
      <div
        className={`sideBar${props.cold ? " sideBar--cold" : ""}`}
        style={window.innerWidth < 550 ? { display: "none" } : {}}
      >
        <div style={{ padding: "10px" }}>
          <Link to="/">
            <img
              src="img/logo_main.png"
              style={{ width: "60%", margin: "20px" }}
              alt="logo"
            />
          </Link>
        </div>
        <div className="sideBarNavWrap">
          <div className="sideNav">
            {/* STEP 1 – ROOM SHAPE (/mode) */}
            <div className="sideBarLi">
              <div
                className={
                  "side_nav_circle " +
                  (Number(props.page) === 1 ? "active" : "")
                }
              >
                <Link to="/mode">
                  <svg
                    style={{ marginTop: "7px" }}
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.124512"
                      y="0.0244141"
                      width="16.7046"
                      height="16.7046"
                      fill="#8D8D8D"
                    />
                  </svg>
                </Link>
              </div>
              <Link to="/mode">
                <span className={Number(props.page) === 1 ? "active" : ""}>
                  {t("Room shape")}
                </span>
              </Link>
            </div>
            <div
              className={
                "side_nav_divider " + (Number(props.page) === 1 ? "active" : "")
              }
            />

            {/* STEP 2 – ROOM SIZE (shares route with layout page) */}
            <div className="sideBarLi">
              <div
                className={
                  "side_nav_circle " +
                  (Number(props.page) === 2 ? "active" : "")
                }
              >
                <Link to={roomStepLink}>
                  <ReactSVG src={item5} style={{ marginTop: "6px" }} />
                </Link>
              </div>
              <Link to={roomStepLink}>
                <span className={Number(props.page) === 2 ? "active" : ""}>
                  {t("Room size")}
                </span>
              </Link>
            </div>
            <div
              className={
                "side_nav_divider " + (Number(props.page) === 2 ? "active" : "")
              }
            />

            {/* STEP 3 – COLD SPOTS (same base route as Room size) */}
            <div className="sideBarLi">
              <div
                className={
                  "side_nav_circle " +
                  (Number(props.page) === 3 ? "active" : "")
                }
              >
                <Link to={roomStepLink}>
                  <ReactSVG src={item4} style={{ marginTop: "3px" }} />
                </Link>
              </div>
              <Link to={roomStepLink}>
                <span className={Number(props.page) === 3 ? "active" : ""}>
                  {t("Cold spots")}
                </span>
              </Link>
            </div>
            <div
              className={
                "side_nav_divider " + (Number(props.page) === 3 ? "active" : "")
              }
            />

            {/* COLD SPOT CONTROLS */}
            <div
              className="spec_box side-cold-spot-box"
              style={
                props.cold === true
                  ? {
                      marginLeft: "-8px",
                      width: "95%",
                      height: "214px",
                      borderRadius: "20px",
                      border: "1px solid #FC0A0A",
                      overflow: "hidden",
                    }
                  : { display: "none" }
              }
            >
              <div
                className="side-cold-field"
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "self-start",
                }}
              >
                <span className="side-cold-field__label" style={{ color: "#FFB800" }}>{t("Width")}</span>
                <input
                  className="side-cold-field__input"
                  style={{
                    color: "white",
                    border: "none",
                    borderBottom: "2px solid #FFB800",
                    backgroundColor: "transparent",
                    width: "60px",
                    outline: "none",
                    marginLeft: "10px",
                  }}
                  type="number"
                  value={stateSpotW}
                  step="1"
                  onChange={(e) => {
                    setStateSpotW(e.target.value);
                  }}
                />
                <span className="side-cold-field__unit" style={{ color: "#FFB800" }}>cm</span>
              </div>

              <div
                className="side-cold-field"
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "self-start",
                }}
              >
                <span className="side-cold-field__label" style={{ color: "#FFB800" }}>{t("Height")}</span>
                <input
                  className="side-cold-field__input"
                  style={{
                    color: "white",
                    border: "none",
                    borderBottom: "2px solid #FFB800",
                    backgroundColor: "transparent",
                    width: "60px",
                    outline: "none",
                    marginLeft: "10px",
                  }}
                  type="number"
                  value={stateSpotH}
                  step="1"
                  onChange={(e) => {
                    setStateSpotH(e.target.value);
                  }}
                />
                <span className="side-cold-field__unit" style={{ color: "#FFB800" }}>cm</span>
              </div>
              <div className="cold_spot_wrap">
                <svg
                  onClick={() => {
                    setStateSpot(1);
                  }}
                  className={stateSpot === 1 ? "active" : ""}
                  width="27"
                  height="27"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.124512"
                    y="0.0244141"
                    width="16.7046"
                    height="16.7046"
                    fill="#626B8B"
                  />
                </svg>

                <svg
                  onClick={() => {
                    setStateSpot(2);
                  }}
                  className={stateSpot === 2 ? "active" : ""}
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.624023 0.813477L26.3813 26.5708H0.624023V0.813477Z"
                    fill="#626B8B"
                  />
                </svg>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <button
                  className="side-cold-create-button"
                  style={{
                    borderRadius: "30px",
                    border: "none",
                    padding: "8px 20px",
                    cursor: "pointer",
                    background: "cornflowerblue",
                    color: "white",
                    textTransform: "uppercase",
                  }}
                  onClick={() => {
                    props.spotFunc(stateSpot, stateSpotW, stateSpotH);
                  }}
                >
                  {t("Spot")}
                </button>
              </div>
              <p
                className="side-cold-note"
                style={{
                  color: "red",
                  fontSize: "10px",
                  padding: "2px 8px",
                  textAlign: "center",
                }}
              >
                *Cold spots that are outside the room <br /> will be removed!
              </p>
            </div>

            <div
              style={props.cold === true ? {} : { display: "none" }}
              className={
                "side_nav_divider " + (Number(props.page) === 3 ? "active" : "")
              }
            />

            {/* STEP 4 – FLOOR TYPE (/floortype) */}
            <div className="sideBarLi">
              <div
                className={
                  "side_nav_circle " +
                  (Number(props.page) === 4 ? "active" : "")
                }
              >
                <Link to="/floortype">
                  <ReactSVG src={item3} style={{ marginTop: "5px" }} />
                </Link>
              </div>
              <Link to="/floortype">
                <span className={Number(props.page) === 4 ? "active" : ""}>
                  {t("Floor type")}
                </span>
              </Link>
            </div>
            <div
              className={
                "side_nav_divider " + (Number(props.page) === 4 ? "active" : "")
              }
            />

            {/* STEP 5 – THERMOSTAT (on the layout pages with ?thermo=1) */}
            <div className="sideBarLi">
              <div
                className={
                  "side_nav_circle " +
                  (Number(props.page) === 5 ? "active" : "")
                }
              >
                <Link to={thermoStepLink}>
                  <ReactSVG src={item1} style={{ marginTop: "4px" }} />
                </Link>
              </div>
              <Link to={thermoStepLink}>
                <span className={Number(props.page) === 5 ? "active" : ""}>
                  {t("Thermostat")}
                </span>
              </Link>
            </div>
            <div
              style={Number(props.page) === 5 ? {} : { display: "none" }}
              className={
                "side_nav_divider " + (Number(props.page) === 5 ? "active" : "")
              }
            />

            {/* THERMOSTAT LIST */}
            <div
              className="spec_box side-thermostat-list"
              style={
                props.addThermo
                  ? {
                      marginLeft: "-8px",
                      width: "95%",
                      height: "330px",
                      borderRadius: "20px",
                      border: "2px solid orange",
                      overflow: "auto",
                    }
                  : { display: "none" }
              }
            >
              {stateThermostats.map((itm, i) => {
                const isActiveRow =
                  currentPopupThermo === itm.id || addedThermo === itm.id;

                return (
                  <div
                    key={itm.id}
                    className="side-thermostat-row"
                    style={{
                      fontSize: "12px",
                      margin: "10px 12px 4px 0px",
                      display: "flex",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => {
                      setCurrentPopupThermo(itm.id);
                      setThermoPopup(1);
                    }}
                    onMouseLeave={() => {
                      setThermoPopup(0);
                    }}
                    onFocus={() => {
                      setCurrentPopupThermo(itm.id);
                      setThermoPopup(1);
                    }}
                    onBlur={() => setThermoPopup(0)}
                    tabIndex={0}
                  >
                    <span className="side-thermostat-row__main">
                      <span
                        className={
                          isActiveRow ? "list_bullet active" : "list_bullet"
                        }
                      >
                        {i + 1}
                      </span>
                      <span
                        className="side-thermostat-row__name"
                        style={{
                          display: "inline-block",
                          maxWidth: "100px",
                          height: "15px",
                          overflow: "hidden",
                          verticalAlign: "middle",
                        }}
                      >
                        {itm.name}
                      </span>
                    </span>
                    <button
                      className="add_button_plus"
                      style={
                        currentPopupThermo === itm.id && addedThermo !== itm.id
                          ? { visibility: "visible" }
                          : { visibility: "hidden" }
                      }
                      onClick={() => {
                        setAddedThermo(
                          props.addThermo(itm.id, itm)[0].getAttr("id")
                        );
                      }}
                      aria-label={`Add ${itm.name}`}
                    >
                      +
                    </button>
                  </div>
                );
              })}
            </div>

            <div
              className={
                "side_nav_divider " +
                (Number(props.page) === 5 || Number(props.page) === 6
                  ? "active"
                  : "")
              }
            />

            {/* STEP 6 – RESULT (/result) */}
            <div className="sideBarLi">
              <div
                className={
                  "side_nav_circle " +
                  (Number(props.page) === 6 ? "active" : "")
                }
              >
                <Link to="/result">
                  <ReactSVG src={item2} style={{ marginTop: "4px" }} />
                </Link>
              </div>
              <Link to="/result">
                <span className={Number(props.page) === 6 ? "active" : ""}>
                  {t("Result")}
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {(props.cold || props.addThermo) && (
        <aside
          className={`mobile-tool-tray${
            props.addThermo ? " mobile-tool-tray--thermostat" : ""
          }${props.cold ? " mobile-tool-tray--cold-spots" : ""}`}
        >
          <button
            type="button"
            className="mobile-tool-tray__toggle"
            aria-expanded={mobileToolsOpen}
            onClick={() => setMobileToolsOpen((open) => !open)}
          >
            {props.cold ? t("Cold spots") : t("Thermostat")}
            <span aria-hidden="true">{mobileToolsOpen ? "−" : "+"}</span>
          </button>

          {mobileToolsOpen && props.cold && (
            <section className="mobile-tool-tray__panel" aria-label={t("Cold spots")}>
              <div className="mobile-cold-spot-fields">
                <label>
                  <span>{t("Width")}</span>
                  <span className="mobile-number-field">
                    <input
                      type="number"
                      min="1"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      enterKeyHint="done"
                      value={stateSpotW}
                      onChange={(event) => setStateSpotW(event.target.value)}
                    />
                    <span>cm</span>
                  </span>
                </label>
                <label>
                  <span>{t("Height")}</span>
                  <span className="mobile-number-field">
                    <input
                      type="number"
                      min="1"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      enterKeyHint="done"
                      value={stateSpotH}
                      onChange={(event) => setStateSpotH(event.target.value)}
                    />
                    <span>cm</span>
                  </span>
                </label>
              </div>

              <div className="mobile-cold-spot-shapes" role="radiogroup" aria-label={t("Cold spots")}>
                <button
                  type="button"
                  role="radio"
                  aria-checked={stateSpot === 1}
                  className={stateSpot === 1 ? "active" : ""}
                  onClick={() => setStateSpot(1)}
                >
                  <span className="mobile-spot-shape mobile-spot-shape--rectangle" />
                  {t("Rectangle form")}
                </button>
                <button
                  type="button"
                  role="radio"
                  aria-checked={stateSpot === 2}
                  className={stateSpot === 2 ? "active" : ""}
                  onClick={() => setStateSpot(2)}
                >
                  <span className="mobile-spot-shape mobile-spot-shape--triangle" />
                  {t("Triangle")}
                </button>
              </div>

              <div className="mobile-tool-tray__actions">
                {props.clearSpotFunc && (
                  <button type="button" className="mobile-tool-secondary" onClick={props.clearSpotFunc}>
                    {t("Remove all")}
                  </button>
                )}
                <button
                  type="button"
                  className="mobile-tool-primary"
                  onClick={() => {
                    props.spotFunc(stateSpot, stateSpotW, stateSpotH);
                    setMobileToolsOpen(false);
                  }}
                >
                  {t("Spot")}
                </button>
              </div>
            </section>
          )}

          {mobileToolsOpen && props.addThermo && (
            <section className="mobile-tool-tray__panel mobile-thermostat-list" aria-label={t("Thermostat")}>
              {stateThermostats.map((thermostat) => (
                <button
                  type="button"
                  key={thermostat.id}
                  className={addedThermo === thermostat.id ? "active" : ""}
                  onClick={() => {
                    setAddedThermo(
                      props.addThermo(thermostat.id, thermostat)[0].getAttr("id")
                    );
                    setMobileToolsOpen(false);
                  }}
                >
                  <img
                    src={
                      thermostat.img && thermostat.img !== "test"
                        ? thermostat.img
                        : "img/thermo1.png"
                    }
                    alt=""
                  />
                  <span>{thermostat.name}</span>
                  <span aria-hidden="true">+</span>
                </button>
              ))}
            </section>
          )}
        </aside>
      )}

      {/* THERMOSTAT PREVIEW POPUP */}
      <div
        className="thermostat-preview-card"
        onMouseEnter={() => setThermoPopup(1)}
        onMouseLeave={() => setThermoPopup(0)}
        style={
          thermoPopup === 1
            ? {
                border: "1px solid orange",
                borderRadius: "10px",
                backgroundColor: "rgb(141, 141, 141)",
                color: "#000000",
                position: "absolute",
                inset: "0 0 0 0",
                margin: "auto",
                width: "260px",
                height: "450px",
                zIndex: 100,
                fontWeight: "600",
                marginLeft: "260px",
                boxShadow:
                  "0 8px 24px rgba(0, 0, 0, 0.25), 0 2px 6px rgba(0, 0, 0, 0.15)",
              }
            : { display: "none" }
        }
      >
        {currentPopupThermo && Object.keys(thermo_objs).length > 0 && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "35px",
              }}
            >
              <img
                style={{
                  width: "160px",
                  borderRadius: "10px",
                  maxHeight: "300px",
                }}
                alt="thermostat"
                src={
                  thermo_objs[currentPopupThermo].name &&
                  thermo_objs[currentPopupThermo].img !== "test" &&
                  thermo_objs[currentPopupThermo].img !== ""
                    ? thermo_objs[currentPopupThermo].img
                    : "img/thermo1.png"
                }
              />
            </div>
            <div
              style={{
                textAlign: "left",
                padding: "4px 20px 4px 20px",
              }}
            >
              <p style={{ fontWeight: "bold", marginBottom: "6px" }}>
                {thermo_objs[currentPopupThermo].name}
              </p>
              <p
                style={{
                  fontSize: "12px",
                  maxHeight: "200px",
                  overflow: "hidden",
                  lineHeight: 1.4,
                  opacity: 0.9,
                }}
              >
                {thermo_objs[currentPopupThermo].description}
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Panel;
